import React from 'react';
import { sortBy } from 'lodash/collection';
import { isEqual, isFunction, isUndefined } from 'lodash/lang';

import Common from '../../../../../common/common';
import Select from '../../../../../common/data-entry/Select';
import { ALLOW_READ } from '../../Protocol/ProtocolSetup/ProtocolGroupsSetup/permissionType';

import 'react-super-select/lib/react-super-select.css';
import './DropdownTemplate.scss';

class DropdownTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initial: null,
      optionsList: []
    };
  }

  componentDidMount() {
    this.setState({ optionsList: this.getOptionsList() });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      !isEqual(prevState.optionsList, this.state.optionsList) ||
      !isEqual(prevProps.fullData, this.props.fullData) ||
      !isEqual(
        this.state.optionsList,
        sortBy(this.props.fullData.codeDefinationList, [
          item => (item.inputType === 'multiselect' ? '' : item.sequence)
        ])
      )
    ) {
      if (this.props.fullData?.codeDefinationList[0]?.inputType === 'multiselect') {
        this.setState({ optionsList: this.props.fullData.codeDefinationList, initial: this.getInitValue() });
      } else {
        const optionsList = this.getOptionsList();
        if (!isEqual(prevState.optionsList, optionsList)) {
          const initialDropdownValue = optionsList.filter(e => e.id === this.getInitValue()?.id)[0];
          this.setState({ optionsList, initial: initialDropdownValue });
        }
      }
    }
  }

  getCommaOnAfterItem = (length, itemIndex) => {
    if (length > 1) {
      if (length - 1 === itemIndex) {
        return '';
      }
      return ',';
    }
    return '';
  };

  customSelectedValueTemplateFunction = selectedItems => {
    return (
      <div className="selected-dropdown-items">
        {selectedItems.map((item, index) => {
          return (
            <span key={item.id ? item.id : Common.getRandomNumber()}>
              {item.name}
              {this.getCommaOnAfterItem(selectedItems.length, index)}
            </span>
          );
        })}
      </div>
    );
  };

  getOptionsList = () => {
    try {
      const dropdownOption = [];
      sortBy(this.props.templateData, [item => item.sequence]).forEach(item => {
        item.id = item.codeId || item.measurement_def_id || `dId${Common.getRandomNumber()}`;
        item.name = item.decode || item.symbol || item.name;
        item.name = item.name ? item.name.trim() : item.name;

        if (item.hasOwnProperty('decode') && item.decode) {
          item.decode = item.decode.trim();
        }
        if (item.hasOwnProperty('codedValue') && item.codedValue) {
          item.codedValue = item.codedValue.trim();
        }
        if (item.decode !== null && item.decode !== '') {
          dropdownOption.push(item);
        }
      });
      return dropdownOption;
    } catch (e) {
      return [];
    }
  };

  customOptionTemplateFunction = item => {
    return (
      <span
        className={this.props.templateData[0]?.inputType === 'multiselect' ? 'option-item' : null}
        title={item.name}
      >
        {item.name}
      </span>
    );
  };

  getInitValue() {
    try {
      if (
        this.props.fullData &&
        this.props.fullData.hasOwnProperty('codeDefinationList') &&
        this.props.fullData.codeDefinationList[0].inputType === 'multiselect'
      ) {
        const parseData = this.props.fullData.inputValue && JSON.parse(this.props.fullData.inputValue);
        const tmp = [];
        parseData.forEach(d => {
          const found = this.props.fullData.codeDefinationList.filter(a => {
            return a.name && a.name.trim() === d;
          });
          if (found.length) {
            tmp.push(found[0]);
          }
        });
        return tmp;
      }

      const filterData = this.props.templateData.filter(o => {
        return o.name && o.name.trim() === this.props.fullData.inputValue?.trim();
      });

      if (filterData.length) {
        return {
          id:
            filterData[0].codeId ||
            filterData[0].measurement_def_id ||
            filterData[0].id ||
            `dId${Common.getRandomNumber()}`,
          name: filterData[0].decode || filterData[0].symbol || filterData[0].name
        };
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  resolveTooltipTitle = (isMultiSelect, selectedValue) => {
    if (isMultiSelect) {
      const parsedValue = selectedValue?.map(e => e.name);
      return parsedValue?.join(', ') || null;
    }
    return selectedValue?.name || null;
  };

  render({ props, state } = this) {
    // Currently input type is stored in code level for custom items. In a future should be changed to be stored in item_defination.
    const isMultiSelect =
      props.templateData && props.templateData.length > 0 && props.templateData[0].inputType === 'multiselect';
    const disabled = isFunction(props.isAbleToEdit) && !props.isAbleToEdit();

    const permissionType = props?.groupAssignPermissionType;
    const disabledByAccess = permissionType === ALLOW_READ;
    const selectedValue = this.state.initial;
    const tooltipTitle = this.resolveTooltipTitle(isMultiSelect, selectedValue);

    return (
      <div
        className={
          props.customClassObject && props.customClassObject.containerClass
            ? props.customClassObject.containerClass
            : ''
        }
      >
        <div className="d-flex col-md-12 p-0">
          <div className="p-0 width100 d-inline-flex item-group-body-dropdown-tooltip">
            <Select
              title={tooltipTitle}
              disabled={disabled || disabledByAccess}
              placeholder="Select"
              clearSearchOnSelection
              dataSource={this.state.optionsList}
              onChange={option => this.onChangeSelect(option)}
              searchable
              deselectOnSelectedOptionClick={isMultiSelect}
              customOptionTemplateFunction={this.customOptionTemplateFunction}
              customSelectedValueTemplateFunction={this.customSelectedValueTemplateFunction}
              clearable
              style={{ width: '100%' }}
              onClear={() => {
                this.onChangeSelect(null);
              }}
              value={this.state.initial}
              multiple={isMultiSelect}
              className="width100 eds-dropdown-template"
              legacyLook
              closeOnSelectedOptionClick={!isMultiSelect}
              keepOpenOnSelection={isMultiSelect}
            />
          </div>
        </div>
      </div>
    );
  }

  onChangeSelect(option) {
    if (isEqual(option, this.state.initial)) {
      return;
    }

    if (!isUndefined(option)) {
      this.setState({
        initial: option
      });
      return (
        this.props.onChangeDropDownHandler &&
        this.props.onChangeDropDownHandler(option, this.props.formLabelId, this.props.itemId, this.props.fullData)
      );
    }
  }
}

export default DropdownTemplate;
